export default "__VITE_ASSET__35wLbNX1__";